
import {Link} from "react-router-dom";
import ConfirmDeletePopup from "../../fragments/popup/ConfirmDeletePopup";

const ItemActions = (props) => (
    <span>
        <Link to={props.viewUrl} state={props.viewState}>
            <i className="bi">View</i>
        </Link>
        <br />
        <Link to={props.editUrl} state={props.editState}>
            <i className="bi bi-pen">Edit</i>
        </Link>
        <br/>
        {props.showPublish && props.publishAction && (
            <>
                <button 
                    className="btn btn-sm btn-success"
                    onClick={props.publishAction}
                    style={{margin: '2px', padding: '2px 6px', fontSize: '12px'}}
                >
                    Publish
                </button>
                <br/>
            </>
        )}
        <ConfirmDeletePopup
            onConfirm={props.onConfirm}
            prompt={`Are you sure to delete ${props.itemName} ?`}
            acceptLabel="Delete"
        />
    </span>
)

export default ItemActions;